var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'story-container': !_vm.isMenuMiniSize, 'story-container-thin-menu': _vm.isMenuMiniSize}},[(_vm.$route.path === '/dashboard/story' || _vm.$route.path === '/client/story')?_c('StoryList',{attrs:{"PCTRLLOG":_vm.CTRLLOG}}):_vm._e(),_vm._v(" "),(_vm.$route.path.indexOf('/dashboard/story/edit') >= 0 || _vm.$route.path.indexOf('/client/story/edit') >= 0)?_c('StoryEdit'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65bbe049","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DashBoard/Story/Story.vue
// module id = null
// module chunks = 